import { authedApiFetch } from 'utils/Api';

const salesforceRaiseMetricsService = {
	getRaiseMetrics: async (entityId) => {
		const response = await authedApiFetch({
			endpoint: `/salesforce_entities/${entityId}/raise_metrics`,
			method: 'GET',
		});
		return response;
	},
};

export default salesforceRaiseMetricsService;
